module.exports = __webpack_public_path__ + "media/images/grade/D-64b4f1ca1eb525f6920d05e3f69e6751.svg";